import { useVerifyPhoneNumberGateQuery } from '@pm/graphql';
import { useCallback, useMemo } from 'react';
import PhoneVerification from '../../modules/phone-number-verification/PhoneVerification';

export const useVerifyPhoneNumberGate = ({
  supportLink,
}: {
  supportLink: string;
}) => {
  const { data, loading, refetch } = useVerifyPhoneNumberGateQuery({
    fetchPolicy: 'cache-and-network',
  });

  const enabled =
    data?.featureConfigurations?.phoneNumberVerificationGate === true;
  const meData = data?.me;
  const phoneNumber = meData?.phone?.e164 || meData?.phone?.rawNumber;
  const voicemailConsent = meData?.voicemailConsent;

  const gateContent = useCallback(
    () => (
      <PhoneVerification
        supportLink={supportLink}
        phoneNumber={phoneNumber ?? ''}
        voicemailConsent={voicemailConsent ?? false}
        onComplete={() => {
          refetch();
        }}
      />
    ),
    [supportLink, phoneNumber, voicemailConsent, refetch],
  );

  return useMemo(() => {
    return {
      loading,
      enabled,
      gateContent,
    } as const;
  }, [loading, enabled, gateContent]);
};
